import React, { useEffect, useState } from "react";
import CommonTable from "../../based/CommonTable";
import { INITPAGING, NOTIFY } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import Loading from "../../based/Loading";
import { Notify } from "../../based/Notify";
import EmbroideryServices from "../../based/services/EmbroideryServices";

function MachineListTab(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });

    useEffect(() => {
        _getData({ ...INITPAGING });
    }, []);

    async function _getData(newPaging) {
        setIsBusy(true);
        let [err, data] = await EmbroideryServices.GetMachines(newPaging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging({ ...INITPAGING });
        }
        setIsBusy(false);
    }

    function _handleDelete(id) {
        ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa máy thêu này", () => {
            return new Promise(async (resolve, reject) => {
                let [err, data] = await EmbroideryServices.DeleteMachine(id);
                if (!err && data) {
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                    _getData(paging);
                } else {
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                }
            });
        });
    }

    function _renderAction() {
        return (
            <button
                className='btn btn-custom'
                onClick={() => {
                    if (props.history) props.history.push("/embroidery-machine-detail/0");
                }}
            >
                <i className='fa fa-plus mr-2'></i>
                Thêm máy
            </button>
        );
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className='text-center'>
                    <th>Dòng máy</th>
                    <th>Mã máy</th>
                    <th>Số đầu kim</th>
                    <th>Hành động</th>
                </tr>
            </thead>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{item.controllerModel}</td>
                                <td>{item.name}</td>
                                <td className='text-center'>{item.needleBarCount}</td>
                                <td className='text-center'>
                                    <button
                                        className='btn btn-custom m-1'
                                        onClick={() => {
                                            if (props.history) props.history.push(`/embroidery-machine-detail/${item.id}`);
                                        }}
                                    >
                                        Chi tiết
                                    </button>
                                    <button className='btn btn-danger m-1' onClick={() => _handleDelete(item.id)}>
                                        Xóa
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={4} className='text-center'>
                            Không có dữ liệu
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    return (
        <React.Fragment>
            <Loading show={isBusy} msg='Đang tải dữ liệu...' />
            <CommonTable data={datas} paging={paging} hideSearch renderAction={_renderAction} renderHeader={_renderHeader} renderBody={_renderBody} onFilter={_getData} />
        </React.Fragment>
    );
}

export default MachineListTab;
